export default {
  ready: false,
  loadingProgressPercentage: 0,
  activeNavTab: null,
}
